export var permissions = {
  INTERNAL_ADMIN: 'internalAdmin',
  ACCOUNT_MANAGER_ADMIN: 'accountManagerAdmin',
  ORGANISATION_ADMIN: 'organisationAdmin',
  WRITE: 'write',
  READ: 'read',
  NO_ACCESS: 'noAccess'
};